const uz = {
  buyExam: "Mock Sotib Olish",
  makePayment: "To'lov Amalga Oshirish",
  candidateDetails: "Foydalanuvchi Haqida Ma'lumot",
  fullName: "To'liq Ism",
  phoneNumber: "Telefon Raqam",
  email: "Elektron Pochta",
  fillDetails: "Ma'lumotlaringizni to'ldiring",
  residenceCountry: "Fuqarolingiz",
  Other: "Boshqa",
  Uzbekistan: "O'zbekiston",
  passportNo: "Passport yoki ID raqam (AA1234567)",
  invalidPassportNo: "Iltimos, to'g'ri passport yoki ID raqam kiriting.",
  dob: "Tug'ilgan sana",
  wrongPassportOrDob:
    "Iltimos, to'g'ri passport raqami yoki tug'ilgan sana kiriting.",
  proceed: "Davom etish",
  firstName: "Ism (PASSPORT bo'yicha)",
  lastName: "Familiya (PASSPORT bo'yicha)",
  disclaimer: "Ogohlantirish",
  disclaimerText:
    "Ushbu TKT mock imtihon materiallari norasmiy bo‘lib, Cambridge English tomonidan tasdiqlanmagan yoki unga aloqador emas. Barcha mazmun, jumladan, savollar, javoblar va tushuntirishlar, Edu-Action Exams Centre tomonidan yaratilgan va to‘liq noyobdir. Taqdim etilgan materiallar faqatgina amaliyot maqsadida mo‘ljallangan bo‘lib, hech qanday rasmiy TKT imtihoni mazmunini takrorlamaydi. Ushbu sinovlarning asosiy maqsadi nomzodlarga vaqt chegarasi bilan haqiqiy imtihon muhitini yaratib berishdir. Nomzodlar ishonchli ma'lumotlar olish uchun rasmiy Cambridge English resurslariga murojaat qilishlari kerak.",
  processingFee: "Ustama",
  totalPay: "To'lov umumiy summasi",
  price: "Narx",
  cardNo: "Karta raqami",
  validThru: "Amal qilish muddati",
  phoneNo: "Telefon raqami",
  enterCode: "SMSdan kodni kiriting",
  pay: "TO'LOV QILISH",
  securePaymentTitle: "Xavfsiz to'lov jarayoni:",
  securePayment1:
    "Sizning xavfsizligingiz bizning ustunlikimizdir. Biz sizning karta ma'lumotlaringizni saqlamaymiz. Barcha to'lovlar xavfsiz ravishda",
  securePayment2: "orqali ishlaydi. ",
  codeSent: "Kod yuborilgan raqam ",
  paidSuccess: "Mock imtihon uchun to'lov muvaffaqiyatli amalga oshirildi",
  moduleNA:
    "Hozircha bu modulda testlar mavjud emas. Iltimos, keyinroq tekshiring.",
  selectModule: "Modulni tanlang",
  passportOrDobWrong:
    "Passport yoki tug'ilgan sanangiz xato, iltimos tekshiring",
  testDetails: "Mock imtihon ma'lumotlari",
  finished: "Tugatilgan",
  boughtOn: "Sotib olingan sana:",
  takeTest: "Testni boshlash",
  takeTest1: "Mock testni",
  takeTest2: "boshlash",
  changePassword: "Parolni o'zgartirish",
  logout: "Chiqish",
  registerTitle: "Mock Test Ro'yxatdan O'tish",
  register: "Ro'yxatdan O'tish",
  password: "Parol",
  passwordConfirm: "Parolni Tasdiqlash",
  alreadyRegistered: "Ro'yxatdan o'tganmisiz? Kirish",
  smthWentWrong: "Nimadir noto'g'ri bo'ldi, iltimos qayta urinib ko'ring",
  enterCorrectPhone: "Iltimos, to'g'ri telefon raqamini kiriting",
  passwordsNotMatch: "Parollar mos kelmaydi",
  repeatPassword: "Parolingizni takrorlang",
  atLeast6: "Kamida 6 ta belgi bo'lishi kerak",
  enterPassword: "Iltimos, parolingizni kiriting",
  enterEmail: "Iltimos, emailingizni kiriting",
  enterPhone: "Iltimos, telefon raqamingizni kiriting",
  enterLastName: "Iltimos, familiyangizni kiriting",
  enterFirstName: "Iltimos, ismingizni kiriting",
  loginText: "Kirish uchun akkount ma'lumotlaringizdan foydalaning",
  login: "Kirish",
  forgotPassword: "Parolni unutdingizmi",
  notRegistered: "Ro'yxatdan o'tmaganmisiz?",
  submit: "Yuborish",
  checkYourEmail: "Iltimos, emailingizni tekshiring",
  forgotPasswordText:
    "Iltimos, parolni tiklash havolasini olish uchun ro'yxatdan o'tgan emailingizni ishlating.",
  enterNewPassword: "Iltimos, yangi parolni kiriting",
  enterOldPassword: "Iltimos, eski parolni kiriting",
  passwordsShouldMatch: "Yangi va tasdiqlangan parollar mos kelishi kerak",
  resetPasswordText: "Iltimos, yangi parol o'ylab toping.",
  resetPassword: "Parolni tiklash",
  newPassword: "Yangi parol",
  oldPassword: "Eski parol",
  changePasswordText:
    "Iltimos, yangi parol o'rnatish uchun eski parolingizni foydalaning.",
  backHome: "Asosiy sahifaga qaytish",
  trainings: "O'quv-seminar videolar",
  mockExams: "Mock imtihonlar",
  training: "O'quv-seminar",
  videos: "video",
  video: "Video",
  playlist: "Pleylist",
  watch: "Ko'rish",
};
export default uz;
